// 获取预定信息
const getOrderDec = require('./sendRequest.js').getOrderDec
const orderNeedKnow = require('../templates/orderNeedKnow.ejs')
const ticketCalendarPrice = require('./extraService').run
//请求静态数据
var write = $.orderInfo

//引入初始化验证模块
const InitValidator = require('./initValidator.js')

//引入用户点击支付时，检查信息是否填写完整的模块
const isComplete = require('./isComplete.js')

function ticketNumAdd () {
    $('.t-o-c-number-add').click(() => {
        let nums = $('#ticketNum').val()
        $('#ticketNum').val(parseInt(nums) + 1)
        ticketTotalMoney(true)
        addUserInfoInput(true)
        changeIdType()
    })

}

function ticketNumDic () {
    $('.t-o-c-number-decrease').click(() => {
        let nums = $('#ticketNum').val()
        $('#ticketNum').val(parseInt(nums) - 1)
        ticketTotalMoney(true)
        addUserInfoInput()
        changeIdType()
    })
}

//用户改变数量
function ticketNumChange () {
    $(document).delegate('#ticketNum', 'blur', function () {
        ticketTotalMoney(true)
    })
}

//计算总共钱数
function ticketTotalMoney (add) {
    ticketLimit(add)
    let nums = $('#ticketNum').val()
    let price = $('.t-o-c-price').text().substr(1)
    //需求2010单结使用预收款功能优化
    let balance = $.orderInfo.data.distributorAccount.balance
    let totalMoney = parseInt(nums) * Number(price)
    $('#usePerPayment').val(balance >= totalMoney ? totalMoney : balance)

    $('.theTotalMoney').text(isNaN(totalMoney) ? '输入错误' : totalMoney.toFixed(2))
    $('.theTotalNums').text(isNaN(parseInt(nums)) ? '' : `(${nums}张)`)
    let str = $.orderInfo.data.ticketPriceModel.clauseDescShow
    $('.cancelRule').text(str)
}

//门票张数的限制
function ticketLimit (add) {
    let nums = parseInt($('#ticketNum').val())
    let numMin = parseInt($.orderInfo.data.minStockCount) || 1
    let numMax = parseInt($.orderInfo.data.maxStockCount) || 20
    // let domLength = $('.ticketUserInfoDetail').length
    $('#ticketNum').val(numMin)
    if (numMin || numMax) {
        if (nums < numMin) {
            $('#ticketNum').val(numMin)
            if (add) {
              layer.open({
                title: '提示'
                ,content: '门票数量最少选择' + numMin + '张'
              });
            }

            // $('.addUserInfo').hide()

        } else if (nums > numMax) {
            $('#ticketNum').val(numMax)
            if (add) {
              layer.open({
                title: '提示'
                ,content: '门票数量最多选择' + numMax + '张'
              });
            }

            // $('.addUserInfo').show()

        } else if (nums <= numMax && nums >= numMin) {
            $('#ticketNum').val(nums)
            // if (domLength > nums) {
            //     for (let i = 0; i < domLength - nums; i++) {
            //         $('.ticketUserInfoDetail').last().remove()
            //     }
            //     if (nums == $('.ticketUserInfoDetail').length) {
            //         $('.addUserInfo').hide()
            //     }
            // } else if (domLength < nums) {
            //      $('.addUserInfo').show()

            // } else {
            //      $('.addUserInfo').hide()
            // }
        } else {
          console.log(nums)
            if (nums == 0) {
                $('#ticketNum').val(1)
            } else if (nums < 0) {
                $('#ticketNum').val(1)
            } else if (nums > 20) {
                $('#ticketNum').val(20)
            }
        }
    }
}

// 实名制isRealName为1的情况，新增要根据一张票几个人，倍数增加填写每个人信息
function addUserInfoInput (add) {
    let data = $.orderInfo.data
    console.log(data)
    if (data.isRealName !== 1) {
      return
    }
    // console.log(' data.isRealNameNum', data);
    let calcNum = 1
    if(data.isRealNameNum) {
        calcNum = data.isRealNameNum.split('_').reduce((total, cur) => {return Number(total) + Number(cur)})
    }
    let manPerTicket = calcNum > 0 ? calcNum : 1
    // 实名成倍渲染游客输入框
    let ticketNumInfo = $('#ticketNum').val() * manPerTicket
    let ticketTotalNum = $('.t-o-c-ticket-userinfo').find('.ticketUserInfoDetail').length

    if (add) {
        for (let j =0;j < ticketNumInfo - ticketTotalNum;j++) {
            let copyParent = $('.ticketUserInfoDetail').eq(0)
            let copyChild = copyParent.clone()

            // 证件类型都修改为身份证，不受父组件影响
            copyChild.find(".inputCardId").attr('name', 'voucherCard')

            copyChild.find('input').each((i, e) => {
                $(e).val('')
            })
            copyParent.after(copyChild)
            $('.ticketUserInfoTitle').each((i, e) => {
                // if (i > 0) {
                //     $(e).find('.removeUserInfo').removeClass('hidden')
                // }
                $(e).find('.touristIndex').html(`游客${i + 1}`)
            })
        }
    } else {
           for (let i = 0; i < ticketTotalNum - ticketNumInfo; i++) {
                $('.ticketUserInfoDetail').last().remove()
            }
    }
}

// function addUserInfo () {
//     $('.addUserInfo').click(() => {
//         let ticketNum = $('#ticketNum').val()
//         let ticketTotalNum = $('.t-o-c-ticket-userinfo').find('.ticketUserInfoDetail').length
//         let copyParent = $('.ticketUserInfoDetail').eq(0)
//         let copyChild = copyParent.clone()
//         if (ticketNum > ticketTotalNum) {
//             copyChild.find('input').each((i, e) => {
//                 $(e).val('')
//             })
//             copyParent.after(copyChild)
//             if (ticketNum == $('.ticketUserInfoDetail').length) {
//                 $('.addUserInfo').hide()
//             }
//             $('.ticketUserInfoTitle').each((i, e) => {
//                 if (i > 0) {
//                     $(e).find('.removeUserInfo').removeClass('hidden')
//                 }
//                 $(e).find('.touristIndex').html(`游客${i + 1}`)
//             })
//         }

//     })
// }

function ticketUserInfoDetail () {
    $('.useUserInfoBtn').click(() => {
        if ($('.useUserInfo').prop('checked')) {
            let name = $('.t-o-c-userFirstName').val().trim() + $('.t-o-c-userLastName').val().trim()
            let tel = $('.ticketTel').val()
            let mail = $('.ticketMail').val()
            $('.connectionName').val(name)
            $('.connectionTel').val(tel)
            $('.connectionMail').val(mail)
        } else {
            $('.connectionName').val('')
            $('.connectionTel').val('')
            $('.connectionMail').val('')
        }

    })
}

function removeUserInfo () {
    $(document).delegate('.removeUserInfo', 'click', (e) => {
        $(e.target).parent().parent().remove()
        // if ($('#ticketNum').val() > $('.ticketUserInfoDetail').length) {
        //     $('.addUserInfo').show()
        // }
    })
}

//点击结算方式切换
function changePayMethod () {
    $('#balance-way').change(function () {

        let method = $(this).find(`option[value = ${this.value}]`).text().trim()
        $(this).attr('data-method', method)
    })
}

//点击详情弹出弹框
function ticketOrderInfo () {
    $(document).undelegate('.t-o-c-button', 'click').delegate('.t-o-c-button', 'click', function (e) {
        let _this = $(this)
        let params = {}
        if ($.orderInfo) {
            params.ticketTypeId = $.orderInfo.data.ticketPriceModel.ticketType
            params.rateTypeId = $.orderInfo.data.ticketPriceModel.priceType
            params.ticketRangeId = $.orderInfo.data.ticketPriceModel.ticketRangeId
        } else {
            params.ticketTypeId = _this.parent().parent().find('.jump-order-btn').attr('data-tickettype')
            params.rateTypeId = _this.parent().parent().find('.jump-order-btn').attr('data-pricetype')
            params.ticketRangeId = _this.parent().parent().find('.jump-order-btn').attr('data-ticketrangeid')
        }

        getOrderDec(params, function (res) {
            if (res.returnCode === 1) {
                if (res.data) {
                    res.data.pickTime ? res.data.pickTime : res.data.pickTime = ''
                    res.data.pointAdress ? res.data.pointAdress : res.data.pointAdress = ''
                    res.data.effectiveDesc ? res.data.effectiveDesc : res.data.effectiveDesc = ''
                    res.data.pickMode ? res.data.pickMode = res.data.pickMode.replace(/[\u9a74\u5988\u5988]{3}/, '') : ''
                    res.data.pointAdress ? res.data.pointAdress = res.data.pointAdress.replace(/[\u9a74\u5988\u5988]{3}/, '') : ''
                    res.data.remark ? res.data.remark = res.data.remark.replace(/[\u9a74\u5988\u5988]{3}/, '') : ''

                    layer.open({
                        type: 1,
                        area: ['860px'], //宽高
                        title: '购买详情须知',
                        content: orderNeedKnow(res.data),
                        skin: 'alert-content',
                        maxHeight: '700px',
                        scrollbar: false
                    })
                    $('.importantNotice').html(res.data.remark)
                    $('.t-o-c-pop').parent().css({'overflow-y': 'scroll'})
                } else {
                    alert('暂无详情')
                }
            } else {
                alert(res.errinfo)
            }

        })
    })
}

//用户切换确认方式时，自动将用户预留的相关信息显示在对应区域内
function changeConfirmWay () {
    $('.other-confirm-way').click(function () {
        var confirmWay = $(this).attr('confirm-way')
        var confirmId = '#' + $(this).attr('confirm-way')

        //先清空确认方式下所有输入框的内容并设为只读
        $('.confirm-way-msg li input').val('').siblings('i').hide()
        //再显示当前确认方式下的内容
        $('.confirm-way-msg').find(confirmId).val(write.content.distributor[confirmWay]).siblings('i').show()

        //更改验证规则
        $('input[name^=voucher]').each(function (i, n) {
            $(n).rules('remove', 'required')

            if ($(n).hasClass('usingPlaceHolder')) {		//***  针对IE浏览器有placeholder的特殊情况进行特殊处理
                n.value = ''
            }

            $(n).focus()
            $(n).blur()
        })

        //给当前确认方式添加必填验证
        $(confirmId).rules('add', {
            required: true, messages: {
                required: $(confirmId).attr('title') + '不能为空'
            }
        })
    })
}

//用户填写了姓或名或护照任何一个时，同一栏的其他信息也必填
function validateTheSame () {
    $('.guest').on('keyup blur', 'input', function () {
        if ($(this).closest('.guest').find('input').val()) {
            $(this).closest('.guest').find('input').valid()
        } else {
            $(this).closest('.guest').find('input').valid(false)
        }
    })
}

function validateConnection () {
    $('.useUserInfo').change(() => {
        if ($(this).prop('checked') == true) {
            $(this).closest('.t-o-c-ticket-connection').find('.warning-txt').each((i, e) => {
                $(e).hide()
            })
        }
    })
}

//用户选择使用预收款时，数目不能小于0，不能大于需要支付的总金额，不能大于能预支付的总金额
function limitPerPayment () {
    $('#usePerPayment').keyup(function () {

        //判断用户所能预支付的最大款项
        var totalPayment = Number($('.theTotalMoney').text())

        var maxPayment = $.orderInfo.data.distributorAccount.balance > totalPayment ? totalPayment : $.orderInfo.data.distributorAccount.balance

        var payMent = +$(this).val()

        if (payMent > maxPayment) {
            $('#usePerPayment').rules('add', {max: maxPayment})
            $('#usePerPayment').valid()
        }
    })
}

//限制用户输入的客户订单号最长为64个字符
function customerCode () {
    $('input[name="customerOrderCode"]').keyup(function () {
        $(this).valid()
    })
}

//限制用户输入的客户订单号最长为64个字符
function changeIdType () {
    $('.cardTypeChosse').each(function(i,e) {
        $(e).on("change",function() {
            let $info = $(this).closest(".confirm-way-msg").find("#cardIdInfo");

            if ($(this).val() === '1'){
                $info.attr('name', 'voucherCard');
            }else{
                $info.attr('name', 'voucherOtherCard');
            }
        })
    })
}

module.exports = {
    run: function () {
        //用户点击加减操作
        ticketTotalMoney()
        ticketNumAdd()
        ticketNumDic()
        ticketNumChange()
        ticketCalendarPrice()
        // addUserInfo()
        addUserInfoInput(true)
        removeUserInfo()
        ticketUserInfoDetail()

        //切换身份证类型
        changeIdType()

        //切换收费方式
        changePayMethod()

        //用户点击查看预定详情
        ticketOrderInfo()

        //初始化验证
        InitValidator()

        validateTheSame()

        //用户切换确认方式时，自动将用户预留的相关信息显示在对应区域内
        changeConfirmWay()

        //用户使用预收款时，数目不能小于0，不能大于需要支付的总金额或能预支付的总金额
        limitPerPayment()

        //用户点击支付时，检查信息是否填写完整
        isComplete()

        //限制用户输入的客户订单号最长为64个字符
        customerCode()
    },
    validateTheSame: validateTheSame,
    ticketTotalMoney: ticketTotalMoney,
    ticketOrderInfo: ticketOrderInfo
}



// WEBPACK FOOTER //
// ./src/js/ticketOrderConfirm/modules/initActive.js